import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { CommonConstant, DateFormate } from 'src/app/constants/common-constant';
import { TestConstant } from 'src/app/constants/label-constants';
import { EncrDecrService } from 'src/app/services/EncrDecr.service';
import { CommonService } from 'src/app/services/common/common.service';
import { SharedService } from 'src/app/services/shared.service';
import { QuestionType } from 'src/app/enum/question-enum';
import { Location } from '@angular/common';
@Component({
  selector: 'app-student-result',
  templateUrl: './student-result.component.html',
  styleUrls: ['./student-result.component.scss']
})
export class StudentResultComponent {
  dateConstant: any = [];
  enum: typeof QuestionType = QuestionType;
  TestConstant: any = [];
  CommonConstant: any = [];
  TestSubmitId: number = 0;
  StudentResult: any = [];
  QuestionsList: any = [];
  AllQuestionsList: any = [];

  constructor(
    public commonService: CommonService,
    private apiUrl: ApiUrlHelper,
    private spinner: NgxSpinnerService,
    private sharedService: SharedService,
    private EncrDecr: EncrDecrService,
    private route: ActivatedRoute,
    private _location: Location
  ) { }

  ngAfterViewInit() {
  }

  ngOnInit(): void {
    this.dateConstant = DateFormate;
    this.TestConstant = TestConstant;
    this.CommonConstant = CommonConstant;
    this.route.params.subscribe((params) => {
      if (params['id'] !== undefined) {
        var decrypted = params['id'] ? params['id'] : '';
        this.TestSubmitId = Number(this.EncrDecr.get('123456$#@$^@1ERF', decrypted));
      }
    })
    if (this.TestSubmitId > 0) {
      this.getStudentResultDeatils(this.TestSubmitId);
    }
    else {
      this.TestSubmitId = 0;
    }
    this.sharedService.setData('Exam Result');
  }

  backButtoEvent() {
    this._location.back();
  }
  getStudentResultDeatils(testSubmitId: number) {
    this.spinner.show();
    const apiUrl = this.apiUrl.apiUrl.test.StudentTestResult.replace("{id}", testSubmitId.toString());
    this.commonService.doGet(apiUrl).pipe().subscribe({
      next: async (response) => {
        this.spinner.hide();
        if (response.success) {
          this.spinner.hide();
          this.StudentResult = response.data
          this.AllQuestionsList = response.data.questions
          response.data.questions.forEach(element => {
            if (element.questionTypeId != 5) {
              this.QuestionsList.push(element);
            }
            if (element.questionTypeId == 5) {
              if (this.QuestionsList.findIndex(x => x.pargaraphText == element.paragraphText) < 0) {
                var obj = {
                  questionTypeId: element.questionTypeId,
                  pargaraphText: element.paragraphText,
                  paragraphQuestion: [] as any
                }
                response.data.questions.forEach(element => {
                  if (element.questionTypeId == 5 && element.paragraphText == obj.pargaraphText) {
                    obj.paragraphQuestion.push(element);
                  }
                })
                this.QuestionsList.push(obj);
              }
            }
          });
        }
        else {
          this.spinner.hide();
        }
      },
      error: (error) => {
        this.spinner.hide();
      }
    });
  }

  timeConvert(n: number) {
    var hours = (n / 60);
    var rhours = Math.floor(hours);
    var minutes = (hours - rhours) * 60;
    var rminutes = Math.round(minutes);
    if (rhours == 0) {
      return rminutes + " min"
    }
    else if (minutes == 0) {
      return rhours + " hr";
    }
    else {
      return rhours + " hr : " + rminutes + " min";
    }
  }

  calculateTimeDifference(startDateTime: any, endDateTime: any): any {
    const timeDifference = endDateTime.getTime() - startDateTime.getTime();
    const seconds = Math.floor(timeDifference / 1000);
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const remainingSeconds = seconds % 60;
    const formattedTime = `${this.padZero(hours)}:${this.padZero(minutes)}:${this.padZero(remainingSeconds)}`;
    return formattedTime;
  }

  padZero(num: number): string {
    return num < 10 ? `0${num}` : `${num}`;
  }

  calculatedPercentage(correctAnswers: number, totalQuestions: number): number {
    return (correctAnswers / totalQuestions) * 100;
  }

  correctAns(option) {
    let correctAns = option.filter(x => x.isCorrectOption == true);
    return correctAns[0].optionText;
  }

  stopCheckingStates(event) {
    if (event.target.checked) {
      event.preventDefault();
      event.stopPropagation();
    }
  }
}


